import styled from 'styled-components';
import {cssBlockResponsive} from '../../utils/propsUtils';
import {boxCss} from '../../styles/box.styled';
import {textCss} from '../../styles/text.styled';
import {alignCss} from '../../styles/align.styled';

const flexConfig = ({viewport}) => {
  const setting = {
    xs: true
  };
  return cssBlockResponsive(viewport, setting,
    `
  flex-direction: column;
  `);
};

const childConfig = ({viewport, blocks}) => {
  if (Array.isArray(blocks)) {
    const css = blocks.map((block, index) => {
      return `
      > div:nth-child(${index + 1}) {
           ${boxCss({box: block.box, viewport})}
           ${alignCss({align: block.align, viewport})};
           ${textCss({text: block.text, viewport})};
        }
    `;
    }).reduce((prev, current) => prev + current);
    return css;
  }
  return '';
};

export const HorizContainer = styled.div`
  .dfl-cms-horizontal-container {
    display: flex;
    flex-direction: row;

    > div {
      width: 100%;
    }

    ${flexConfig}
    ${childConfig}
    .dlf-no-margin-horizontal {
      margin: 0;
    }
  }
`;

HorizContainer.defaultProps = {};

